import registry from '../utils/registry';

export default registry();
